import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: {
    detail: {
      type: Object,
      default: {}
    },
    transfereeInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      citytitle: ''
    };
  },
  computed: {
    ...mapGetters({
      getTenantParams: 'getTenantParams'
    }),
    district () {
      return this.detail.address.split(' ') && this.detail.address.split(' ')[2];
    },
    town () {
      return this.detail.address.split(' ') && this.detail.address.split(' ')[3];
    },
    word () {
      if (!['yingshang', 'linquan'].includes(this.getTenantParams.href)) {
        return this.getTenantParams.citytitle + '农村产权交易市场留取竞价佣金后剩余部分违约金归';
      }
      return '';
    },

    word1() {
      if (!['yingshang', 'linquan'].includes(this.getTenantParams.href)) {
        return '竞价保证金扣除动态报价佣金后，转为部分成交价款。如竞价保证金不足以抵扣动态报价佣金，承租方应及时补足。';
      }
      return '公示期满5个工作日内未成交部分的竞价保证金原路返回。';
    },

    word2() {
      if (!['yingshang', 'linquan'].includes(this.getTenantParams.href)) {
        return '竞价保证金扣除动态报价佣金后，转为部分成交价款。如竞价保证金不足以抵扣动态报价佣金，受让方应及时补足。';
      }
      return '公示期满5个工作日内未成交部分的竞价保证金原路返回。';
    }
  },
  created () {
    console.log(this.detail, 'this.detail', this.transfereeInfo);
    // console.log(this.detail.addressDetail.split(' ')[2], 'detail.addressDetail');
  },
  mounted () {
    this.$nextTick(function () {
      this.$refs.box.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600 && this.transfereeInfo.bidType !== 7) {
        this.$emit('enabledBtn');
      }else if(scrollTop >= 1100 && this.transfereeInfo.bidType === 7){
        this.$emit('enabledBtn');
      }
    }
  }
};
